import React from 'react'
import Placeholder from './Placeholder'
import SimpleCentered from './SimpleCentered'
import LogoCloudsSlider from './LogoCloudsSlider'
import SplitWithImagesSlider from './SplitWithImagesSlider'
import WithFeatureGridList from './WithFeatureGridList'
import ThreeColumnCards from './ThreeColumnCards'
import Testimonial from './Testimonial'
import SplitWithGridOnRight from './SplitWithGridOnRight'
import SimpleCenteredBranded from './SimpleCenteredBranded'
import MultiCards from './MultiCards'
import ThreeColumnPillars from './ThreeColumnPillars'
import ContentHeadingCentered from './ContentHeadingCentered'
import Content from './Content'
import WithLargeImages from './WithLargeImages'
import SimpleFourColumn from './SimpleFourColumn'

/* Marketing / PageSections / ContentSections */
import Centered from './Marketing/PageSections/ContentSections/Centered'
import SimpleThreeColumn from './SimpleThreeColumn'
import SplitWithImage from './Marketing/PageSections/ContentSections/SplitWithImage'
import TwoColumns from './Marketing/PageSections/ContentSections/TwoColumns'
import TwoColumnsWithImage from './Marketing/PageSections/ContentSections/TwoColumnsWithImage'
import TwoColumnsWithTestimonial from './Marketing/PageSections/ContentSections/TwoColumnsWithTestimonial'
import WithTestimonialAndStats from './Marketing/PageSections/ContentSections/WithTestimonialAndStats'
import Stat from './Marketing/PageSections/ContentSections/Stat'
import FullWidthImage from './Marketing/PageSections/ContentSections/FullWidthImage'

/* Marketing / PageSections / Contact Sections */
import ContactCentered from './Marketing/PageSections/ContactSections/Centered'
import ThankYou from './ThankYou'

/* Marketing / PageSections / CTA Sections */
import BrandPanelOverlappingImage from './Marketing/PageSections/CTASections/brand-panel-with-overlapping-image'
import BrandPanelAppScreenshot from './Marketing/PageSections/CTASections/brand-panel-with-app-screenshot'
import SimpleJustified from './Marketing/PageSections/CTASections/simple-justified'

/* Marketing / PageSections / FAQs */
import OffsetSupportingText from './Marketing/PageSections/FAQs/offset-supporting-text'

/* Marketing / PageSections / Testimonials */
import TestimonialsSimpleCentered from './Marketing/PageSections/Testimonials/SimpleCentered'

/* Marketing / Feedback / 404 Pages */
import Simple404 from './Marketing/Feedback/404Pages/simple'

/* TBB */
import CenteredAccordion from './TBB/Accordions/centered-accordion'
import Hero from './TBB/Heros/Hero'
import HeroSlimline from './TBB/Heros/HeroSlimline'
import DefaultContent from './TBB/DefaultContent/DefaultContent'

/* Custom */
import GoogleMap from './Custom/GoogleMap'
import Video from './Custom/Video'
import Accordion from './Accordion'

/* Forms */
import Form from "./Form"
import TextInput from "./Forms/Components/TextInput"
import EmailInput from "./Forms/Components/EmailInput";
import TextAreaInput from "./Forms/Components/TextAreaInput";
import FileInput from "./Forms/Components/FileInput";
import NumberInput from "./Forms/Components/NumberInput";
import SelectInput from "./Forms/Components/SelectInput";
import CodeBlock from "./CodeBlock"
import popup from "./popup";
import ContactImformation from "./ContactImformation";
import FeatureCard from "./FeatureCard";

/* RESKIN/NEW */
import { 
  Accordion1Block,
  Accordion2Block,
  ArticleBlock,
  CTACardBlock,
  FooterBlock,
  BasicTextInput,
  InlineForm,
  Checkbox,
  Dropdown,
  Textarea,
  ContactInformationBlock,
  SectionTitle,
  Image,
  ThreePillars,
  StatementWithOwnerOfStatement,
  Hotspot,
  ContentWrapper,
  Label
} from '@/components/block'
import StepsBlock from './block/StepsBlok'
import RelatedContentCard from './RelatedContentCard'

const Components = {
  hero: Hero,
  popup: popup,
  "hero-slimline": HeroSlimline,
  "simple-centered": SimpleCentered,
  ContactImformation:ContactImformation,
  'hero-slimline': HeroSlimline,
  'simple-centered': SimpleCentered,
  FeatureCard: FeatureCard,
  /* Marketing / PageSections / ContentSections */
  'split-with-image': SplitWithImage,
  centered: Centered,
  'two-columns': TwoColumns,
  'two-columns-with-image': TwoColumnsWithImage,
  'two-columns-with-testimonial': TwoColumnsWithTestimonial,
  'simple-three-column': SimpleThreeColumn,
  'with-testimonial-and-stats': WithTestimonialAndStats,
  'full-width-image': FullWidthImage,
  stat: Stat,
  /* Marketing / Feedback / 404 Pages */
  'simple-404': Simple404,
  /* Marketing / PageSections / CTA Sections */
  'brand-panel-overlapping-image': BrandPanelOverlappingImage,
  'brand-panel-app-screenshot': BrandPanelAppScreenshot,
  'simple-justified': SimpleJustified,
  /* Marketing / PageSections / FAQs */
  'offset-with-supporting-text': OffsetSupportingText,
  /* Marketing / PageSections / Contact Sections */
  'contact-centered': ContactCentered,
  'thank-you': ThankYou,
  /* Marketing / PageSections / Testimonials */
  'testimonial-simple-centered': TestimonialsSimpleCentered,
  /* TBB */
  'centered-accordion': CenteredAccordion,
  'default-content': DefaultContent,
  /* Custom */
  video: Video,
  'google-map': GoogleMap,
  'with-feature-grid-list': WithFeatureGridList,
  'logo-clouds-slider': LogoCloudsSlider,
  'three-column-cards': ThreeColumnCards,
  testimonial: Testimonial,
  // "accordion": Accordion,
  accordion: Accordion1Block,
  accordion2: Accordion2Block,
  'split-with-images-slider': SplitWithImagesSlider,
  'split-with-grid-on-right': SplitWithGridOnRight,
  'simple-centered-branded': SimpleCenteredBranded,
  'multi-cards': MultiCards,
  'three-column-pillars': ThreeColumnPillars,
  /* Forms */
  form: Form,
  'text-input': TextInput,
  'email-input': EmailInput,
  'textarea-input': TextAreaInput,
  'file-input': FileInput,
  'number-input': NumberInput,
  'select-input': SelectInput,
  'content-heading-centered': ContentHeadingCentered,
  content: Content,
  'with-large-images': WithLargeImages,
  'simple-four-column': SimpleFourColumn,
  code_block: CodeBlock,

  /** NEW **/
  article_block: ArticleBlock,
  cta_card_block: CTACardBlock,
  footer_block: FooterBlock,
  basic_input_text: BasicTextInput,
  inline_form: InlineForm,
  checkbox: Checkbox,
  dropdown: Dropdown,
  textarea: Textarea,
  contact_information_block: ContactInformationBlock,
  section_title: SectionTitle,
  image: Image,
  "steps-block": StepsBlock,
  three_pillars: ThreePillars,
  statement_with_owner_of_statement: StatementWithOwnerOfStatement,
  RelatedContentCard:RelatedContentCard, 
  Hotspot: Hotspot,
  content_wrapper: ContentWrapper,
  label: Label
}

const DynamicComponent = ({ blok, page }) => {
  if (typeof Components[blok.component] !== 'undefined') {
    const Component = Components[blok.component]
    return <Component blok={blok} key={blok._uid} page={page} />
  }

  return blok.component ? <Placeholder componentName={blok.component} /> : null
}

export default DynamicComponent
